import {firebase} from './firebase';

export const getCartByUser = (idUser, idRestaurant, callback) =>
  firebase.database().ref('users_carts/'+idUser+'/'+idRestaurant).on("value", (cart) => {
    callback(cart);
});

export const removefromCart = (idUser, idRestaurant, idItem) => firebase.database().ref('users_carts/'+idUser+'/'+idRestaurant+'/items').child(idItem).remove().then((result) => {
  changeTotalCart(idUser, idRestaurant);
}).catch((error)=> {
  console.log("error");
});

export const changeUserCart = (idUser, idRestaurant, idItem, quantity, item_price) =>
  firebase.database().ref('users_carts/'+idUser+'/'+idRestaurant+'/items').child(idItem).update({
      quantity : quantity,
      total_item_price: item_price*quantity
  }).then((result) => {
    changeTotalCart(idUser, idRestaurant);
  }).catch((error)=> {
    console.log("error");
  });
  
  const changeTotalCart  = async (idUser, idRestaurant) =>
  firebase.database().ref('users_carts/'+idUser+'/'+idRestaurant+'/items').on("value",((items) => {
    var total = 0;
    var quantity = 0;
    Object.entries(items.val()||[]).forEach(async (item) => {
      total =  total + item[1].total_item_price;
      quantity = quantity + item[1].quantity;
    });

    if(items.val()===null){
      firebase.database().ref('users_carts/'+idUser).child(idRestaurant)
      .remove();
    }
    else{
      firebase.database().ref('users_carts/'+idUser).child(idRestaurant)
      .update({
        products_count : quantity,
        total_price: total
    });
    }
  
  }));



// WEBPACK FOOTER //
// ./src/cartDB.js